import React, { useEffect, useState } from "react"
import { Route, Routes } from "react-router-dom"
import { useSelector , useDispatch } from 'react-redux'

import { Main   } from "./pages/main"
import { Login  } from "./pages/login"
import { Senshi } from "./pages/senshi"
import { V2     } from "./pages/v2"

const App = () => {

    const state = useSelector((state) => {
        return state
    }); 
  
    const renderData = ()=> { 
        if (state.error) { 
            return <h1>Error</h1>
        }
        else { 
            return (
                <Routes>
                    <Route path='/' element={<Main />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/dashboard' element={<Senshi />} />
                </Routes>
            )
        }
    }

    return renderData()
  }

  export default App